import React from 'react';
import { Droplets, Maximize, Layout, Square, SlidersHorizontal, Bath, DoorOpen, Wrench } from 'lucide-react';
export function ShowerStyles() {
  const styles = [{
    title: 'Frameless Shower Doors',
    copy: 'A clean, modern glass shower door with minimal hardware that keeps the bathroom open, bright and focused on your tile or stone work.',
    icon: Maximize
  }, {
    title: 'Euro Glass Shower Doors',
    copy: 'European-style frameless shower doors made with thick tempered glass and sleek hardware for a luxury, spa-like bathroom feel.',
    icon: Layout
  }, {
    title: 'Semi-Frameless Shower Doors',
    copy: 'A balanced option that combines clean glass lines with added framing support for a polished, practical look.',
    icon: Square
  }, {
    title: 'Framed Glass Shower Doors',
    copy: 'A classic and cost-effective shower door style with frame support, available in multiple finishes and glass options.',
    icon: DoorOpen
  }, {
    title: 'Sliding & Bypass Shower Doors',
    copy: 'Space-saving glass shower doors that work well in tighter bathrooms, tub openings and layouts where a swing door is not ideal.',
    icon: SlidersHorizontal
  }, {
    title: 'Tub Glass Enclosures',
    copy: 'Upgrade a bathtub-shower combination with custom glass panels or doors instead of a shower curtain.',
    icon: Bath
  }, {
    title: 'Walk-In & Barrier-Free Shower Glass',
    copy: 'Fixed panels and custom glass layouts for low-curb, curbless or barrier-free shower designs.',
    icon: Droplets
  }, {
    title: 'Shower Door Replacement & Repair',
    copy: 'Replacement and repair options for damaged, outdated, leaking or poorly fitting glass shower doors and enclosures.',
    icon: Wrench
  }];
  return <section className="py-20 bg-gray-50" data-id="element-1508" data-mp="1tzkabn5yyg06">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1509" data-mp="1yzovhqhtnywq">
        <div className="text-center max-w-3xl mx-auto mb-16 anim-on-scroll" data-id="element-1510" data-mp="19ccbext6zlls">
          <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-6 tracking-normal" data-id="element-1511" data-mp="19a8a8nmoh0p7">
            Custom Shower Glass Designed Around Your Bathroom
          </h2>
          <p className="text-lg text-gray-600" data-id="element-1512" data-mp="1j2xk5e2ky6if">
            Every bathroom is different. Kosin’s Glass helps you choose the
            shower glass, door style, hardware and finish that fit your layout,
            taste and daily routine.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12" data-id="element-1513" data-mp="1n490su3h7heh">
          {styles.map((style, i) => <div key={i} className="bg-white p-8 rounded-lg shadow-card border border-gray-100 hover:shadow-soft transition-shadow scroll-fade-up" style={{
          animationDelay: `${i * 0.1}s`
        }} data-id="element-1514" data-mp="2219uv4953og4" data-mpi={i}>
              <div className="w-12 h-12 bg-glass rounded-lg flex items-center justify-center mb-6 text-primary" data-id="element-1515" data-mp="2o5rd01iux8l">
                <style.icon className="w-6 h-6" data-id="element-1516" data-mp="2eapsuxc5r7nf" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-1517" data-mp="2edlqekk3fubc">
                {style.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1518" data-mp="24lpm2rrez7yo">{style.copy}</p>
            </div>)}
        </div>

        <div className="text-center anim-on-scroll" data-id="element-1519" data-mp="29jr6bg0ktdbq">
          <a href="#quote" className="inline-flex items-center justify-center bg-primary hover:bg-primary-hover text-white font-semibold py-4 px-8 rounded-lg transition-colors shadow-md" data-id="element-1520" data-mp="29i6cjsm35yex">
            Request a Free Shower Glass Quote
          </a>
        </div>
      </div>
    </section>;
}